export default "__VITE_ASSET__C1Xj$m2W__"